import { requireElement } from "@modules/bookmarks/html-elements"
import type { TagInstance } from "@modules/bookmarks/tags/Tag"
import {
    type OptionEvent,
    TagDeleteOptionClickedEvent,
    TagRenameOptionClickedEvent,
} from "@modules/bookmarks/tags/options-dropdown"
import { TagShowNewEvent } from "@modules/bookmarks/tags/tag-list"
import type { JQueryStatic } from "@modules/jquery-types"
import { consumeEvent } from "@modules/util/events"

type JQuery = JQueryStatic & {}
export type TagModalElement = {
    tag: TagInstance
}

const $: JQuery = jQuery as unknown as JQuery

export const tagAddLoginModal = (): (HTMLElement & TagModalElement) | null =>
    requireElement<HTMLElement & TagModalElement>("#tags-login-modal")
export const tagAddModal = (): (HTMLElement & TagModalElement) | null =>
    requireElement<HTMLElement & TagModalElement>("#tag-add-modal")
export const tagDeleteModal = (): (HTMLElement & TagModalElement) | null =>
    requireElement<HTMLElement & TagModalElement>("#tag-delete-modal")
export const tagRenameModal = (): (HTMLElement & TagModalElement) | null =>
    requireElement<HTMLElement & TagModalElement>("#tag-rename-modal")

export const registerTagAddButtonAction = (callback: (ev: MouseEvent) => any): void => {
    requireElement("#tag-save", tagAddModal() ?? document)?.addEventListener("click", callback, { passive: true })
}

export const openTagAddLoginModal = (): void => {
    const modal: (HTMLElement & TagModalElement) | null = tagAddLoginModal()

    if (modal === null) {
        return
    }

    $(modal).modal("show")
}

export const openTagAddModal = (): void => {
    const modal: (HTMLElement & TagModalElement) | null = tagAddModal()

    if (modal === null) {
        return
    }

    $(modal).modal("show")
}

export const closeTagAddModal = (): void => {
    const modal: (HTMLElement & TagModalElement) | null = tagAddModal()

    if (modal === null) {
        return
    }

    $(modal).modal("hide")
}

export const registerTagDeleteButtonAction = (callback: (ev: MouseEvent) => any): void => {
    requireElement("#tag-delete", tagDeleteModal() ?? document)?.addEventListener("click", callback, { passive: true })
}

const openTagDeleteModal = (tag: TagInstance): void => {
    const deleteModal: (HTMLElement & TagModalElement) | null = tagDeleteModal()

    if (deleteModal === null) {
        return
    }

    const tagNameElements = (deleteModal?.querySelectorAll(".tag-name") ?? []) as NodeListOf<HTMLElement>

    deleteModal.tag = tag

    for (const tagName of tagNameElements) {
        tagName.textContent = tag.tagName
    }

    $(deleteModal).modal("show")
}

export const closeTagDeleteModal = (): void => {
    const modal: (HTMLElement & TagModalElement) | null = tagDeleteModal()

    if (modal === null) {
        return
    }

    $(modal).modal("hide")
}

export const registerTagRenameButtonAction = (callback: (ev: MouseEvent) => any): void => {
    requireElement("#tag-rename", tagRenameModal() ?? document)?.addEventListener("click", callback, { passive: true })
}

const openTagRenameModal = (tag: TagInstance): void => {
    const renameModal: (HTMLElement & TagModalElement) | null = tagRenameModal()

    if (renameModal === null) {
        return
    }

    const tagNameElements = renameModal.querySelectorAll(".tag-name") as NodeListOf<HTMLElement>

    renameModal.tag = tag

    for (const tagName of tagNameElements) {
        tagName.textContent = tag.tagName
    }

    $(renameModal).modal("show")
}

export const closeTagRenameModal = (): void => {
    const modal: (HTMLElement & TagModalElement) | null = tagRenameModal()

    if (modal === null) {
        return
    }

    $(modal).modal("hide")
}

export const registerModalEvents = (): void => {
    document.addEventListener(
        TagShowNewEvent,
        consumeEvent((): void => (!userData.isLoggedIn ? openTagAddLoginModal() : openTagAddModal())),
    )
    document.addEventListener(
        TagDeleteOptionClickedEvent,
        consumeEvent((optionEvent: OptionEvent): void => openTagDeleteModal(optionEvent.detail.tag)),
    )
    document.addEventListener(
        TagRenameOptionClickedEvent,
        consumeEvent((optionEvent: OptionEvent): void => openTagRenameModal(optionEvent.detail.tag)),
    )
}

export default {
    closeTagAddModal,
    closeTagDeleteModal,
    closeTagRenameModal,
    registerModalEvents,
    registerTagAddButtonAction,
    registerTagDeleteButtonAction,
    registerTagRenameButtonAction,
    tagAddModal,
    tagDeleteModal,
    tagRenameModal,
}
